/**
 * NOTE if you need to take this any further (more balls, more complex interactions etc)
 * then it will need a rewrite. Use a co-ords system!
 *
 * BTW 0 degress is down, not up in this case, and the angles run counterclockwise (so 90 is left, 180 is up etc)
 */

(function () {
    'use strict';

    const SECONDS_FOR_BALL_TO_CROSS_SCREEN_HYP = 3.5;
    const BALL_EVENT_DEBOUNCE_MS = 80;
    const BALL_ON = true;           // to disable quickly if you need to

    const BounceBall = function (classBoundary) {
        this.ball;
        this.ballWidth;
        this.ballHeight;

        this.boundary = document.querySelector(classBoundary);
        this.boundaryWidth;
        this.boundaryHeight;

        this.ballMaxVelocity;

        this.x = 0;
        this.y = 0;
        this.speedX = 0;
        this.speedY = 0;
        this.ballAngle = 0;
        this.bounceEvent = new CustomEvent('ballBounce');

        this.prevTime;

        this.bounceEventDebouncer;
        this.bounceEventDebounced = false;

        this.init = function () {
            if (this.boundary && BALL_ON) {
                this.setupBoundary();
                this.createBall();
                this.setupBallDimensions();
                this.setBallMaxVelocity();
                this.setBallSpeeds(30 + (Math.random() * 20));
                this.setupBallStartPosition();
                this.checkCollisions();
                this.prevTime = document.timeline.currentTime;
                this.setResizeHandler();
                this.tick();
                this.bindBallClick();
            }
        }

        this.setupBoundary = function () {
            this.boundaryWidth = this.boundary.clientWidth;
            this.boundaryHeight = this.boundary.clientHeight;
        }

        this.setBallMaxVelocity = function () {
            const width = this.boundaryWidth;
            const height = this.boundaryHeight;
            this.ballMaxVelocity = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)) / SECONDS_FOR_BALL_TO_CROSS_SCREEN_HYP;
        }

        this.createBall = function () {
            if (!this.ball) {
                const elmBall = document.createElement('div');
                elmBall.classList.add('ball');
                this.ball = elmBall;
                this.boundary.appendChild(this.ball);
            }
        }

        this.setupBallDimensions = function () {
            this.ballWidth = this.ball.clientWidth;
            this.ballHeight = this.ball.clientHeight;
        }

        this.setupBallStartPosition = function () {
            this.x = this.ballWidth / 2;
            this.y = this.ballHeight / 2;
        }

        this.setBallSpeeds = function (angle) {
            if (angle >= 360 || angle <= 0) {
                angle = 0;
            }

            this.ballAngle = angle;

            const angleInRadians = angle * (Math.PI / 180);
            const hypotenuse = this.ballMaxVelocity;

            const adjacent = hypotenuse * Math.cos(angleInRadians);
            const opposite = hypotenuse * Math.sin(angleInRadians);

            this.speedX = opposite;
            this.speedY = adjacent;

            this.calculateAngleInTravel();
        }

        // this is used to recalc the angle when a collision occurs
        this.calculateAngleInTravel = function () {
            // Calculate the angle in radians
            let angleRadians = Math.atan2(this.speedX, this.speedY);

            // Convert the angle from radians to degrees
            this.ballAngle = angleRadians * (180 / Math.PI);

            // Optional: Ensure the angle is positive (0 to 360 degrees)
            if (this.ballAngle < 0) {
                this.ballAngle += 360;
            }
        }

        this.resizeBallPos = function (differential) {
            this.x = this.x * differential;
            this.y = this.y * differential;
        }


        /**
         * TODO this is a bit of a last minute job
         */
        this.resizeSimulation = function () {
            const newBoundaryWidth = this.boundary.clientWidth;
            const differential = (newBoundaryWidth / this.boundaryWidth)
            this.resizeBallPos(differential)
            this.setupBoundary();
            this.setupBallDimensions();
            this.setBallMaxVelocity();
            this.calculateAngleInTravel();
            this.setBallSpeeds(this.ballAngle);
        }

        this.tick = function (t) {
            // for whatever reason, t may not be defined on first frame
            if (!t) {
                t = this.prevTime;
            }

            const frameTime = t - this.prevTime;

            this.x += this.speedX * (frameTime / 1000);
            this.y += this.speedY * (frameTime / 1000);

            this.checkCollisions();
            this.render();
            this.prevTime = t;
            requestAnimationFrame(this.tick.bind(this));
        }

        this.checkCollisions = function () {
            // TODO this could be made more accurate (at greater speeds, etc)

            const ballWidthHalf = this.ballWidth / 2;
            const ballHeightHalf = this.ballHeight / 2;

            if (this.x - ballWidthHalf < 0) {
                this.x = ballWidthHalf;
                this.speedX = this.speedX * -1;
                this.emitCollisionEvent();
            } else if (this.x + ballWidthHalf > this.boundaryWidth) {
                this.x = this.boundaryWidth - ballWidthHalf;
                this.speedX = this.speedX * -1;
                this.emitCollisionEvent();
            } else if (this.y - ballHeightHalf < 0) {
                this.y = ballHeightHalf;
                this.speedY = this.speedY * -1;
                this.emitCollisionEvent();
            } else if (this.y + ballHeightHalf > this.boundaryHeight) {
                this.y = this.boundaryHeight - ballHeightHalf;
                this.speedY = this.speedY * -1;
                this.emitCollisionEvent();
            }
        }

        this.emitCollisionEvent = function () {
            if (!this.bounceEventDebounced) {
                document.dispatchEvent(this.bounceEvent);
                this.bounceEventDebounced = true;
            }
            this.bounceEventDebouncer = setTimeout(function () {
                this.bounceEventDebounced = false;
            }.bind(this), BALL_EVENT_DEBOUNCE_MS);
        }

        this.render = function () {
            // the ball is midhandled
            this.ball.style.setProperty('--ballTransform', `translate(${this.x - (this.ballWidth / 2)}px, ${this.y - (this.ballHeight / 2)}px)`);
        }

        this.setResizeHandler = function () {
            // TODO debounce this maybe
            window.addEventListener('resize', function () {
                this.resizeSimulation();
            }.bind(this));
        }

        this.bindBallClick = function () {
            this.ball.addEventListener('click', function() {
                document.body.classList.toggle('body--invert');
            });
            /* document.body.addEventListener('click', function (e) {
                const distance = Math.sqrt(Math.pow(this.x - e.clientX, 2) + Math.pow(this.y - e.clientY, 2));

                // TODO will not work with non-spherical ball
                if (distance <= (this.ballWidth / 1.6)) {
                    document.body.classList.toggle('body--invert');
                }
            }.bind(this)); */
        }
    }


    /**
     * Main
     */

    const ball = new BounceBall('.js-ballBoundary');

    ball.init();


})();